import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../../lib/config";

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      className="section-pad"
      style={{ background: "#F0EAE0" }}
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <p className="eyebrow">Questions, Answered</p>
          <h2
            className="font-heading font-medium mt-4"
            style={{
              fontSize: "clamp(2rem, 4vw, 3.4rem)",
              lineHeight: 1.1,
              color: "#122B20",
              letterSpacing: "-0.015em",
            }}
          >
            Everything <span className="gold-italic">Sellers Ask Us.</span>
          </h2>
        </motion.div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.45, delay: i * 0.03, ease: "easeOut" }}
                className="rounded-2xl overflow-hidden"
                style={{
                  background: "#FAF7F2",
                  border: `1px solid ${isOpen ? "rgba(198,161,91,0.5)" : "rgba(168,162,154,0.35)"}`,
                  transition: "border-color 220ms ease",
                }}
                data-testid={`faq-item-${i}`}
              >
                <button
                  className="w-full flex items-start justify-between gap-6 text-left px-5 md:px-7 py-5 md:py-6"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-toggle-${i}`}
                >
                  <span
                    className="font-heading font-medium"
                    style={{
                      color: "#122B20",
                      fontSize: "1.1rem",
                      lineHeight: 1.35,
                    }}
                  >
                    {f.q}
                  </span>
                  <span
                    className="shrink-0 mt-0.5 w-8 h-8 rounded-full flex items-center justify-center"
                    style={{
                      background: isOpen ? "#1B4332" : "rgba(198,161,91,0.14)",
                      border: `1px solid ${isOpen ? "#1B4332" : "rgba(198,161,91,0.5)"}`,
                      transition: "all 220ms ease",
                    }}
                  >
                    {isOpen ? (
                      <Minus size={16} color="#C6A15B" strokeWidth={2} />
                    ) : (
                      <Plus size={16} color="#C6A15B" strokeWidth={2} />
                    )}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.32, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <div className="px-5 md:px-7 pb-6 md:pb-7 pr-14">
                        <p
                          className="font-body text-[#2B2926]/85"
                          style={{ fontSize: "0.98rem", lineHeight: 1.75 }}
                        >
                          {f.a}
                        </p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
